import { getProductIcon } from 'legoland-sdk';
import styled from 'styled-components';
import { Button, Caption, Checkbox, FormGroup, HGrid, InlineText, Input, Label, Select, Text, VGrid, tombac } from 'tombac';
import azureTermsPdf from "./Junction Analytics Azure Jun 2023 BL.pdf";
import ProductCheckbox from "./ProductCheckbox";
import { RegistrationCompanyField } from "./RegistrationCompanyField";
import StyledRegistration from "./StyledRegistrationUi";
import termsPdf from "./TomTom Evaluation Agreement 2023.pdf";
import { useRegistrationForm } from "./useRegistrationForm";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormLayout = styled(HGrid).withConfig({
  displayName: "RegistrationForm__FormLayout"
})(["grid-auto-columns:1fr;gap:", ";@media (max-width:", "){gap:", ";}@media (max-width:", "){grid-auto-flow:row;}"], tombac.space(10), tombac.unit(1023), tombac.space(5), tombac.unit(719));
const CreateButton = styled(Button).withConfig({
  displayName: "RegistrationForm__CreateButton"
})(["width:", ";"], tombac.unit(150));
const RegistrationForm = _ref => {
  let {
    onCreateUser
  } = _ref;
  const {
    formik,
    countryOptions,
    industryOptions,
    getFormGroupProps,
    getInputProps,
    getProductCheckboxProps
  } = useRegistrationForm({
    onCreateUser
  });
  return /*#__PURE__*/_jsxs(StyledRegistration.Page, {
    "data-sentry-element": "unknown",
    "data-sentry-component": "RegistrationForm",
    "data-sentry-source-file": "RegistrationForm.tsx",
    children: [/*#__PURE__*/_jsxs(StyledRegistration.Content, {
      as: "form",
      onSubmit: formik.handleSubmit,
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "RegistrationForm.tsx",
      "data-sentry-element": "unknown",
      children: [/*#__PURE__*/_jsx(StyledRegistration.Heading, {
        level: 1,
        $mb: "1sp",
        "data-sentry-element": "unknown",
        "data-sentry-source-file": "RegistrationForm.tsx",
        "data-sentry-element": "unknown",
        children: "Start your free Traffic Analytics product trial"
      }), /*#__PURE__*/_jsx(StyledRegistration.Heading, {
        as: "p",
        level: 2,
        $mb: "7sp",
        "data-sentry-element": "unknown",
        "data-sentry-source-file": "RegistrationForm.tsx",
        "data-sentry-element": "unknown",
        children: "You'll be up and running in less than a minute."
      }), /*#__PURE__*/_jsxs(FormLayout, {
        "data-sentry-element": "FormLayout",
        "data-sentry-source-file": "RegistrationForm.tsx",
        "data-sentry-element": "FormLayout",
        children: [/*#__PURE__*/_jsxs(VGrid, {
          gap: 3,
          gridAutoColumns: "1fr",
          "data-sentry-element": "VGrid",
          "data-sentry-source-file": "RegistrationForm.tsx",
          "data-sentry-element": "VGrid",
          children: [/*#__PURE__*/_jsx(FormGroup, {
            label: /*#__PURE__*/_jsxs(Label, {
              htmlFor: "email-input",
              children: ["Work e-mail", ' ', /*#__PURE__*/_jsx(Text, {
                $display: "inline",
                variant: "danger",
                children: "*"
              })]
            }),
            ...getFormGroupProps('email'),
            "data-sentry-element": "FormGroup",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "FormGroup",
            children: /*#__PURE__*/_jsx(Input, {
              id: "email-input",
              name: "email",
              placeholder: "Type in your work email",
              ...getInputProps('email'),
              "data-sentry-element": "Input",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Input"
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "first-name-input",
            label: "First name",
            ...getFormGroupProps('firstName'),
            "data-sentry-element": "FormGroup",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "FormGroup",
            children: /*#__PURE__*/_jsx(Input, {
              id: "first-name-input",
              name: "firstName",
              placeholder: "Type in your first name",
              ...getInputProps('firstName'),
              "data-sentry-element": "Input",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Input"
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "last-name-input",
            label: "Last name",
            ...getFormGroupProps('lastName'),
            "data-sentry-element": "FormGroup",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "FormGroup",
            children: /*#__PURE__*/_jsx(Input, {
              id: "last-name-input",
              name: "lastName",
              placeholder: "Type in your last name",
              ...getInputProps('lastName'),
              "data-sentry-element": "Input",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Input"
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            label: /*#__PURE__*/_jsxs(Label, {
              htmlFor: "country-input",
              children: ["Country", ' ', /*#__PURE__*/_jsx(Text, {
                $display: "inline",
                variant: "danger",
                children: "*"
              })]
            }),
            ...getFormGroupProps('country'),
            "data-sentry-element": "FormGroup",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "FormGroup",
            children: /*#__PURE__*/_jsx(Select, {
              id: "country-input",
              invalid: Boolean(formik.touched.country && formik.errors.country),
              isSearchable: true,
              name: "country",
              options: countryOptions,
              placeholder: "Pick your country",
              ...formik.getFieldProps('country'),
              onBlur: () => formik.setFieldTouched('country'),
              onChange: country => !('length' in country) && formik.setFieldValue('country', country.value),
              value: countryOptions.find(o => o.value === formik.values.country),
              "data-sentry-element": "Select",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Select"
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            htmlFor: "industry-input",
            label: "Industry",
            "data-sentry-element": "FormGroup",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "FormGroup",
            children: /*#__PURE__*/_jsx(Select, {
              id: "industry-input",
              invalid: Boolean(formik.touched.industry && formik.errors.industry),
              name: "industry",
              options: industryOptions,
              placeholder: "Pick your industry",
              ...formik.getFieldProps('industry'),
              onBlur: () => formik.setFieldTouched('industry'),
              onChange: industry => !('length' in industry) && formik.setFieldValue('industry', industry.value),
              value: industryOptions.find(i => i.value === formik.values.industry),
              "data-sentry-element": "Select",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Select"
            })
          }), /*#__PURE__*/_jsx(RegistrationCompanyField, {
            formik: formik,
            name: "company",
            "data-sentry-element": "RegistrationCompanyField",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "RegistrationCompanyField"
          })]
        }), /*#__PURE__*/_jsxs(VGrid, {
          gridAutoColumns: "1fr",
          "data-sentry-element": "VGrid",
          "data-sentry-source-file": "RegistrationForm.tsx",
          "data-sentry-element": "VGrid",
          children: [/*#__PURE__*/_jsxs(VGrid, {
            gridAutoColumns: "1fr",
            "data-sentry-element": "VGrid",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "VGrid",
            children: [/*#__PURE__*/_jsxs(Label, {
              $mb: "-1sp",
              "data-sentry-element": "Label",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Label",
              children: ["Select product(s) you would like to try out", ' ', /*#__PURE__*/_jsx(Text, {
                $display: "inline",
                variant: "danger",
                "data-sentry-element": "Text",
                "data-sentry-source-file": "RegistrationForm.tsx",
                "data-sentry-element": "Text",
                children: "*"
              })]
            }), /*#__PURE__*/_jsx(ProductCheckbox, {
              description: "Analyze, predict and improve traffic, to identify congestion bottlenecks and capacity on the road based on historical traffic data reports",
              limits: ['30 days', '20 reports', 'August 2024 data'],
              logo: getProductIcon('ts'),
              name: "Traffic Stats",
              tagline: "Find bottlenecks",
              ...getProductCheckboxProps('ts'),
              "data-sentry-element": "ProductCheckbox",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "ProductCheckbox"
            }), /*#__PURE__*/_jsx(ProductCheckbox, {
              description: "Analyze trip patterns, access and preferred routes, to improve business decisions based on how and where people move.",
              limits: ['30 days', '20 reports', 'August 2024 data'],
              logo: getProductIcon('od'),
              name: "O/D Analysis",
              tagline: "Understand mobility",
              ...getProductCheckboxProps('od'),
              "data-sentry-element": "ProductCheckbox",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "ProductCheckbox"
            }), /*#__PURE__*/_jsx(ProductCheckbox, {
              description: "Monitor real-time traffic on key routes and take proactive action, to broadcast and optimize traffic conditions.",
              limits: ['30 days', '2 routes'],
              logo: getProductIcon('ctm'),
              name: "Route Monitoring",
              tagline: "Monitor current situation",
              ...getProductCheckboxProps('ctm'),
              "data-sentry-element": "ProductCheckbox",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "ProductCheckbox"
            }), /*#__PURE__*/_jsx(ProductCheckbox, {
              description: "Monitor junction turn ratios, current delay, and other valuable traffic information based on gathered real-time traffic data.",
              limits: ['30 days', '1 junction'],
              logo: getProductIcon('ja'),
              name: "Junction Analytics",
              tagline: "Analyze intersections",
              ...getProductCheckboxProps('ja'),
              "data-sentry-element": "ProductCheckbox",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "ProductCheckbox"
            }), formik.touched.products && formik.errors.products && /*#__PURE__*/_jsx(Caption, {
              variant: "danger",
              children: formik.errors.products
            })]
          }), /*#__PURE__*/_jsxs(StyledRegistration.TermsLabel, {
            "data-sentry-element": "unknown",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "unknown",
            children: [/*#__PURE__*/_jsx(Checkbox, {
              label: false,
              name: "termsAgreement",
              $mt: "2sp",
              ...formik.getFieldProps('termsAgreement'),
              "data-sentry-element": "Checkbox",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "Checkbox"
            }), /*#__PURE__*/_jsxs(StyledRegistration.TermsLabelCopy, {
              as: "div",
              "data-sentry-element": "unknown",
              "data-sentry-source-file": "RegistrationForm.tsx",
              "data-sentry-element": "unknown",
              children: ["I have read and agreed with the", ' ', /*#__PURE__*/_jsx(InlineText, {
                as: "a",
                variant: "interactive",
                href: termsPdf,
                target: "_blank",
                "data-sentry-element": "InlineText",
                "data-sentry-source-file": "RegistrationForm.tsx",
                "data-sentry-element": "InlineText",
                children: "Terms and Conditions"
              }), ' ', "for TomTom\u2019s Move portal", ' ', /*#__PURE__*/_jsx(InlineText, {
                variant: "danger",
                "data-sentry-element": "InlineText",
                "data-sentry-source-file": "RegistrationForm.tsx",
                "data-sentry-element": "InlineText",
                children: "*"
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsxs(Caption, {
                  as: "div",
                  variant: "secondary",
                  "data-sentry-element": "Caption",
                  "data-sentry-source-file": "RegistrationForm.tsx",
                  "data-sentry-element": "Caption",
                  children: ["Your personal data is safe with us, see our", ' ', /*#__PURE__*/_jsx(Caption, {
                    variant: "interactive",
                    as: "a",
                    href: "https://www.tomtom.com/en_gb/privacy/",
                    target: "_blank",
                    "data-sentry-element": "Caption",
                    "data-sentry-source-file": "RegistrationForm.tsx",
                    "data-sentry-element": "Caption",
                    children: "Privacy Policy"
                  }), ' ', "for more details."]
                })
              })]
            })]
          }), formik.touched.termsAgreement && formik.errors.termsAgreement && /*#__PURE__*/_jsx(Caption, {
            variant: "danger",
            children: formik.errors.termsAgreement
          }), /*#__PURE__*/_jsx(CreateButton, {
            busy: formik.isSubmitting,
            type: "submit",
            variant: "primary",
            "data-sentry-element": "CreateButton",
            "data-sentry-source-file": "RegistrationForm.tsx",
            "data-sentry-element": "CreateButton",
            children: "Create account"
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        height: '0px',
        width: '0px',
        overflow: 'hidden'
      },
      children: [/*#__PURE__*/_jsx("a", {
        hidden: true,
        href: azureTermsPdf,
        target: "_blank",
        rel: "noreferrer"
      }), ' ']
    })]
  });
};
export default RegistrationForm;